var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmAuthResetPasswordConfirmSucceedImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36ZM53.2468 27.5326C54.2511 26.5284 54.2511 24.9002 53.2468 23.896C52.2426 22.8918 50.6145 22.8918 49.6103 23.896L32.1429 41.3635L23.6754 32.896C22.6712 31.8918 21.0431 31.8918 20.0389 32.896C19.0347 33.9002 19.0347 35.5284 20.0389 36.5326L30.3246 46.8183C31.3288 47.8225 32.9569 47.8225 33.9611 46.8183L53.2468 27.5326Z",
    fill: "#2BC784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmAuthResetPasswordConfirmSucceedImage);
export default __webpack_public_path__ + "static/media/crm-auth-reset-password-confirm-succeed-image.abc6a3702e890dd4641d4b63bbff63fc.svg";
export { ForwardRef as ReactComponent };